const SCROLL_ANIMATION_TRIGGER_CLASSNAME = 'scroll-trigger';
const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = 'scroll-trigger--offscreen';
const SCROLL_ZOOM_IN_TRIGGER_CLASSNAME = 'animate--zoom-in';
const SCROLL_ANIMATION_CANCEL_CLASSNAME = 'scroll-trigger--cancel';

function isTouchUi() {
  return window.matchMedia('(hover: none), (pointer: coarse), (max-width: 959px)').matches;
}

function restartCssAnimation(el) {
  /* Force CSS keyframes to replay when re-entering the viewport */
  el.style.animation = 'none';
  // eslint-disable-next-line no-unused-expressions
  el.offsetWidth;
  el.style.animation = '';
}

function onIntersection(entries) {
  entries.forEach((entry, index) => {
    const el = entry.target;
    if (el.classList.contains(SCROLL_ANIMATION_CANCEL_CLASSNAME)) return;

    if (entry.isIntersecting) {
      if (el.classList.contains(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME)) {
        el.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
        if (el.hasAttribute('data-cascade')) {
          el.setAttribute('style', `--animation-order: ${index};`);
        }
        restartCssAnimation(el);
      }
    } else {
      /* Fully off-screen — re-arm so next enter (up or down) animates again */
      el.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
    }
  });
}

function initializeScrollAnimationTrigger(rootEl = document, isDesignModeEvent = false) {
  const animationTriggerElements = Array.from(rootEl.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME));
  if (animationTriggerElements.length === 0) return;

  if (isDesignModeEvent) {
    animationTriggerElements.forEach((element) => {
      element.classList.add('scroll-trigger--design-mode');
    });
    return;
  }

  animationTriggerElements.forEach((element) => {
    if (!element.classList.contains(SCROLL_ANIMATION_CANCEL_CLASSNAME)) {
      element.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
    }
  });

  /*
    threshold 0: isIntersecting is false only when fully outside the viewport.
    That avoids edge flicker while still replaying after a complete leave.
  */
  const observer = new IntersectionObserver(onIntersection, {
    root: null,
    rootMargin: '0px',
    threshold: 0,
  });
  animationTriggerElements.forEach((element) => observer.observe(element));
}

function initializeScrollZoomAnimationTrigger() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  /* Keep zoom-scrub desktop-only — continuous scroll math can hitch mobile flings */
  if (isTouchUi()) return;

  const animationTriggerElements = Array.from(document.getElementsByClassName(SCROLL_ZOOM_IN_TRIGGER_CLASSNAME));

  if (animationTriggerElements.length === 0) return;

  const scaleAmount = 0.2 / 100;

  animationTriggerElements.forEach((element) => {
    let elementIsVisible = false;
    const observer = new IntersectionObserver((elements) => {
      elements.forEach((entry) => {
        elementIsVisible = entry.isIntersecting;
      });
    });
    observer.observe(element);

    element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));

    window.addEventListener(
      'scroll',
      throttle(() => {
        if (!elementIsVisible) return;

        element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));
      }),
      { passive: true }
    );
  });
}

function percentageSeen(element) {
  const viewportHeight = window.innerHeight;
  const scrollY = window.scrollY;
  const elementPositionY = element.getBoundingClientRect().top + scrollY;
  const elementHeight = element.offsetHeight;

  if (elementPositionY > scrollY + viewportHeight) {
    return 0;
  } else if (elementPositionY + elementHeight < scrollY) {
    return 100;
  }

  const distance = scrollY + viewportHeight - elementPositionY;
  let percentage = distance / ((viewportHeight + elementHeight) / 100);
  return Math.round(percentage);
}

window.addEventListener('DOMContentLoaded', () => {
  initializeScrollAnimationTrigger();
  initializeScrollZoomAnimationTrigger();
});

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => initializeScrollAnimationTrigger(event.target, true));
  document.addEventListener('shopify:section:reorder', () => initializeScrollAnimationTrigger(document, true));
}
